if (!customElements.get('arc-product-discovery')) {
 customElements.define('arc-product-discovery', class extends HTMLElement {
  connectedCallback() {
   this.controller?.abort();
   this.controller = new AbortController();
   const signal = this.controller.signal;
   this.track = this.querySelector('.arc-discovery__track');
   this.previous = this.querySelector('[data-prev]');
   this.next = this.querySelector('[data-next]');
   this.previous.addEventListener('click', () => this.move(-1), {signal});
   this.next.addEventListener('click', () => this.move(1), {signal});
   this.track.addEventListener('scroll', () => this.update(), {signal,passive:true});
   this.track.addEventListener('keydown', event => {
    if (event.target !== this.track || !['ArrowLeft','ArrowRight'].includes(event.key)) return;
    event.preventDefault();this.move(event.key === 'ArrowRight' ? 1 : -1);
   }, {signal});
   this.resize = new ResizeObserver(() => this.update());this.resize.observe(this.track);
   if (this.dataset.mode === 'recent') {
    try {
     this.history = JSON.parse(sessionStorage.getItem('arc_recent_handles') || '[]').filter(h => typeof h === 'string' && /^[a-z0-9-]+$/.test(h) && h !== this.dataset.current).slice(0,6);
     sessionStorage.setItem('arc_recent_handles', JSON.stringify([this.dataset.current,...this.history].slice(0,9)));
    } catch { this.history = []; }
   }
   this.observer = new IntersectionObserver(entries => {
    if (entries.some(e => e.isIntersecting)) {this.observer.disconnect();this.load();}
   }, {rootMargin:'600px'});
   this.observer.observe(this.closest('.shopify-section') || this);
   this.update();
  }
  disconnectedCallback() {this.controller?.abort();this.observer?.disconnect();this.resize?.disconnect();}
  update() {
   this.querySelector('.arc-discovery__controls').hidden = this.track.scrollWidth <= this.track.clientWidth + 2;
   this.previous.disabled = this.track.scrollLeft < 2;
   this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2;
  }
  move(direction) {
   const cards = Array.from(this.track.children);if (!cards.length) return;
   const origin = cards[0].offsetLeft;
   let index = cards.reduce((best,card,i) => Math.abs(card.offsetLeft-origin-this.track.scrollLeft) < Math.abs(cards[best].offsetLeft-origin-this.track.scrollLeft) ? i : best,0);
   index = Math.max(0,Math.min(cards.length-1,index+direction));
   this.track.scrollTo({left:cards[index].offsetLeft-origin,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  }
  async load() {
   try {
    if (this.dataset.mode === 'recent') {
     const root = this.dataset.root.replace(/\/$/,'');
     const results = await Promise.all(this.history.map(async handle => {
      const url = new URL(`${root}/products/${handle}`,location.origin);
      const response = await fetch(url,{signal:this.controller.signal});if (!response.ok) return null;
      const doc = new DOMParser().parseFromString(await response.text(),'text/html');
      return doc.querySelector('template[data-recent-card]')?.content.querySelector('.arc-discovery__card');
     }));
     const existing = new Set(Array.from(document.querySelectorAll('arc-product-discovery:not([data-mode="recent"]) .arc-discovery__card')).map(e=>e.dataset.productHandle));
     for (const card of results) if (card && !existing.has(card.dataset.productHandle) && this.track.children.length < Number(this.dataset.limit)) this.track.append(card);
    } else {
     const url = new URL(this.dataset.url,location.origin);
     url.searchParams.set('product_id',this.dataset.productId);url.searchParams.set('section_id',this.dataset.sectionId);url.searchParams.set('limit','10');url.searchParams.set('intent',this.dataset.mode);
     const response = await fetch(url,{signal:this.controller.signal});if (!response.ok) return;
     const doc = new DOMParser().parseFromString(await response.text(),'text/html');
     const track = doc.querySelector('arc-product-discovery .arc-discovery__track');
     if (track?.children.length) this.track.replaceChildren(...track.children);
    }
    this.hidden = this.track.children.length === 0;this.update();
   } catch { this.hidden = this.track.children.length === 0; }
  }
 });
}
